/**
 * Loads list of string which represent all possible string which can be offered as whispering.
 */
export function loadWhispererSuggestionsListAsPromise(domain: string): Promise<any> {

    const fetchUrl = '/share/ajax/kamery_naseptavac2.php';

    const fetchOptions = {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({domain: domain})
    };

    return fetch(fetchUrl, fetchOptions as RequestInit);
}